export const getFileExtension = (filePath: string): string | undefined => {
    return filePath.split(".").pop()?.toLowerCase().replace(/#.*$/, "");
};
